<template>
    <div id="lo-studio" class="lo-studio section beige" v-if="this.dataLoaded">
        <div class="grid-container" data-aos="new-animation" data-aos-init="aos-init" > 
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <div class="big-title" data-aos="new-animation" data-aos-init="aos-init" >
            <h1 v-html="this.splittedTitle(page.attributes.title)"></h1>
        </div>
        <div class="container">
            <div>
                <h3>{{labelTitle}}</h3>
                <h1 data-aos="new-animation" data-aos-init="aos-init" class="animated-title" v-html="this.page.attributes.title"></h1>
            </div>
            <div class="row">
                <div class="col-md-12 col-lg-6">
                    <h2 >{{this.page.attributes.field_subtitle}}</h2>
                </div>
                <div class="col-md-12 col-lg-6">
                    <p v-html="this.page.attributes.field_description.processed"></p>
                </div>
            </div>
        </div>
        <div class="images-container" data-scroll-container>
            <div class="image-container trieste " data-aos="new-animation" data-aos-init="aos-init" >
                <div class="image-container-outer" >
                    <div class="image-container-inter">
                        <img src="../assets/lo-studio-image-3.png" alt="">
                    </div>
                </div>
            </div>
            <div class="image-container studio" data-scroll-section data-aos="new-animation" data-aos-init="aos-init" >
                <div class="image-container-outer" data-scroll data-scroll-speed="2">
                    <div class="image-container-inter">
                        <img src="../assets/lo-studio-image-2.png" alt="">
                    </div>
                </div>
            </div>
            <!-- <div class="image-container logo" data-aos="new-animation" data-aos-init="aos-init" >
                <div class="image-container-outer">
                    <div class="image-container-inter">
                        <img src="../assets/lo-studio-image-1.png" alt="">
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>




export default {
    name: 'section-lo-studio',
    props: {
        dataPages: {
            type: String
        }
    },
    data:()=>{
        return {
            idIntroPage:"8d40a69e-bbd6-43cf-b53a-dd2237895c59",
            page:[],
            dataLoaded:false
        }
    },
  computed:{
        labelTitle(){
            let label;
            if(this.$route.params.lang == "it"){
                label = "Chi siamo"
            } else {
                label = "About us"
            }
            return label
        }
    },
methods:{
    splittedTitle: function (value) {
        return value.replace(/(?![^<]*>)[^<]/g, c => `<span>${c}</span>\n`);
    },
    findObjectbyKey(array, key, value){
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
        return null;
    }
},
    mounted(){
        fetch("https://ptnlex-api-prod.interfase.tv/"+this.$route.params.lang+"/jsonapi/node/page", {method: "GET", mode: 'cors'})
        .then(response=>{
            return response.json()
        })
        .then(json=>{
            this.page = this.findObjectbyKey(json.data,"id",this.idIntroPage)
            this.dataLoaded = true
        })
        .catch(function(error) {  
            console.log('Request failed', error)  
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



.image-container-fade-in{
    opacity: 1;
}

.images-container {
    z-index: 2;
    position: relative;
    margin-top: 1rem;

    .image-container.trieste{
        position: relative;
        position: absolute;
        width: 683px;
        overflow: hidden;
        height: 483px;
        right: 0;
        transform: translate(0,0);
    }
    .image-container.logo{
        position: absolute;
        width: 319px;
        overflow: hidden;
        height: 230px;
        right: 0;
        transform: translate(-150%, -20%);
    }
    .image-container.studio{
        position: absolute;
        width: 338px;
        overflow: hidden;
        height: 390px;
        right: 0;
        transform: translate(-183%, -16%);
    }
}

.section.lo-studio {
    width: 100%;
    position: relative;
    .big-title {
        margin-top: 4rem;
    }
}
@media (max-width:1500px){
    .section.lo-studio {
        height: 150vh;
    }
}
@media (max-width:1366px){
    .images-container {
        transform: scale(0.8);
        transform-origin: right;
    }
}
@media (max-width:992px){
.section.lo-studio {
    height: auto;
}
}

@media (max-width:768px){
    .section.lo-studio {
    height: auto;
}
}

</style>
